module.exports = __webpack_public_path__ + "static/media/summaryDefault.f0f29b6e.svg";